import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { Modal, Form } from 'components/teamsnapUIExtensions';
import { Button } from '@teamsnap/teamsnap-ui';
import InputField from 'components/baseComponents/Fields/InputField';
import TextAreaField from 'components/baseComponents/Fields/TextAreaField';
import RadioButtonField from 'components/baseComponents/Fields/RadioButtonField';
import { hideModal } from 'state/modal/actions';
import { showFeedback } from 'state/feedback/actions';
import { SUCCESS, ERROR } from 'components/teamsnapUIExtensions/Feedback/Feedback';
import { createInvoiceMessage } from 'state/invoiceMessages/actions';
import { validate } from './validate';
import styles from './ModalSendBatch.module.scss';

class ModalSendBatch extends PureComponent {
  onSubmit = ({ status, subject, body }) => {
    const { batchId, sendBatch } = this.props;

    const message = {
      batch_invoice_id: batchId,
      status,
      subject,
      body,
    };

    if (status === 'open-not-in-progress') {
      message.status = 'open';
      message.hasPaymentSchedule = false;
    }

    sendBatch(message)
      .then(() => this.props.showFeedback(this.feedbackSuccessProps))
      .catch(() => this.props.showFeedback(this.feedbackErrorProps))
      .finally(() => this.handleClose());
  };

  handleClose = () => {
    this.props.closeModal();
  };

  feedbackErrorProps = {
    title: 'Oops!',
    // eslint-disable-next-line
    message:
      'Something went wrong on our end. Please try again, and if the error persists let us know at https://helpme.teamsnap.com/?solvvy=true so we can see what’s going on.',
    type: ERROR,
  };

  feedbackSuccessProps = {
    title: 'You did it!',
    message: 'The invoice has been re-sent to everyone you selected. Show me the money!',
    type: SUCCESS,
  };

  messageOptions = [
    { title: 'Open, not scheduled', value: 'open' },
    { title: 'Paid', value: 'paid' },
    { title: 'Canceled', value: 'canceled' },
    { title: 'All', value: 'all' },
  ];

  render() {
    const { handleSubmit } = this.props;
    return (
      <Modal title="Resend Invoice" handleClose={ this.handleClose }>
        <Form handleSubmit={ handleSubmit(this.onSubmit) }>
          <div className={ styles.ModalBody }>
            <RadioButtonField
              label="Send message to"
              name="status"
              size="fit"
              options={ this.messageOptions }
              className="InputControlInline"
            />

            <InputField name="subject" type="text" label="Subject:" />

            <TextAreaField name="body" label="Text of your email:" placeholder="Add a note here" />
          </div>
          <div className={ styles.ModalFooter }>
            <Button onClick={ this.handleClose } icon="dismiss" color="negative" mods="u-spaceRightSm">
              Cancel
            </Button>

            <Button type="submit" color="primary" icon="mail">
              Resend Invoice
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
}

ModalSendBatch.propTypes = {
  batchId: PropTypes.string.isRequired,
  sendBatch: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  showFeedback: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default connect(null, {
  closeModal: hideModal,
  showFeedback,
  sendBatch: createInvoiceMessage,
})(
  reduxForm({
    form: 'sendBatch',
    validate,
  })(ModalSendBatch),
);
